module.exports = __webpack_public_path__ + "static/media/DSC08896_180531_3.5651fc20.jpg";